import { FC } from 'react'

import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { useMutatePersonalSettings } from '@/services'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'
import {
  KEY_PAGE as KEY_PAGE_2C,
  PartialPaymentsRequest,
  defaultSettings as DEFAULT_SETTINGS_2C,
} from '@/pages/b2c/default-settings-payments.tsx'

import {
  KEY_PAGE as KEY_PAGE_2B,
  PartialSbpPayment,
  defaultSettings as DEFAULT_SETTINGS_2B,
} from '../default-settings.tsx'

const defaultSettingsKey2B = Object.keys(DEFAULT_SETTINGS_2B)

export const SbpPersonalSettings: FC = () => {
  const sbpType = useAppSelector((state) => state.sbpPayments.sbpType)
  const settingsForPayments = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE_2C))
  const settingsForRegistries = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE_2B))

  const getSettings2C = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(DEFAULT_SETTINGS_2C)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: DEFAULT_SETTINGS_2C[e as keyof PartialPaymentsRequest],
      isChecked: true,
    }))
    Object.keys(DEFAULT_SETTINGS_2C).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({
          id: key,
          label: DEFAULT_SETTINGS_2C[key as keyof PartialPaymentsRequest],
          isChecked: false,
        })
      }
    })

    return settings
  }

  const getSettings2B = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(DEFAULT_SETTINGS_2B)
    const settings: RowProps[] = settingsByRequest
      .filter((e) => defaultSettingsKey2B.includes(e))
      .map((e) => ({
        id: e,
        label: DEFAULT_SETTINGS_2B[e as keyof PartialSbpPayment],
        isChecked: true,
      }))
    Object.keys(DEFAULT_SETTINGS_2B).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({ id: key, label: DEFAULT_SETTINGS_2B[key as keyof PartialSbpPayment], isChecked: false })
      }
    })

    return settings
  }

  const mutation = useMutatePersonalSettings()

  return sbpType === 'B2C' ? (
    <PersonCustomizationDialog
      personalSettingsKey={KEY_PAGE_2C}
      mutation={mutation}
      itemsDesktop={getSettings2C('desktop', settingsForPayments)}
      itemsMobile={getSettings2C('mobile', settingsForPayments)}
    />
  ) : (
    <PersonCustomizationDialog
      personalSettingsKey={KEY_PAGE_2B}
      mutation={mutation}
      itemsDesktop={getSettings2B('desktop', settingsForRegistries)}
      itemsMobile={getSettings2B('mobile', settingsForRegistries)}
    />
  )
}
